import * as leaseContractTypes from 'constants/enums/leaseContractTypes'

export default {
  [leaseContractTypes.NEW_LEASE_AGREEMENT]: 'Nová nájemní smlouva',
  [leaseContractTypes.LEASE_AGREEMENT_AMENDMENT]: 'Dodatek k nájemní smlouvě',
  [leaseContractTypes.LEASE_TERMINATION_AGREEMENT]: 'Dohoda o ukončení nájmu',
  [leaseContractTypes.OTHER_LEASE_DOCUMENTS]: 'Ostatní nájemní dokumenty',
  [leaseContractTypes.POWER_OF_ATTORNEY]: 'Plná moc',
  [leaseContractTypes.OTHER]: 'Ostatní',
  [leaseContractTypes.HANDOVER_PROTOCOL]: 'Předávací protokol',
  [leaseContractTypes.NOTICE]: 'Výzva',
  [leaseContractTypes.LEASE_TERMINATION_NOTICE]: 'Výpověď z nájmu',
} as const
